import React from 'react'

import { unified } from 'unified'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import remarkDeflist from 'remark-deflist'
import rehypeRaw from 'rehype-raw'
import rehypeReact from 'rehype-react'

import { Link, links, linkMap } from './link'

import { slug, Slugger } from './slug'

import { iframe } from './iframe'

import { toc, tocTree, redepthTocMap, tocHeadings } from './toc'

const rehypeReactOptions = {
  createElement: React.createElement,
  Fragment: React.Fragment,
  components: {
    a: Link,
  },
}

const renderArticleBase = ({ content = [] } = {}) => {
  let tocMap = []
  let linkList = []
  const processor = unified()
    .use(remarkParse)
    .use(remarkDeflist)
    .use(remarkRehype, { allowDangerousHtml: true })
    .use(rehypeRaw)
    .use(slug, { slugger: new Slugger() })
    .use(toc, { map: tocMap })
    .use(links, { map: linkList })
    .use(iframe)
    .use(rehypeReact, rehypeReactOptions)

  const rendered = content
    .map(({ id, body }) => ({ id, body: processor.processSync(body).result }))
    .reduce((obj, { id, body }) => ({ ...obj, [id]: body }), {})

  tocMap = redepthTocMap(tocMap)
  return {
    tocMap,
    tocTree: tocTree(tocMap),
    tocHeadings: tocHeadings(tocMap),
    linkList,
    linkMap: linkMap(linkList),
    content: rendered,
  }
}

export const renderArticleToc = (article) => {
  const { tocMap, tocTree, tocHeadings } = renderArticleBase(article)
  return {
    tocMap,
    tocTree,
    tocHeadings,
  }
}
export const renderArticleLinks = (article) => {
  const { linkList, linkMap } = renderArticleBase(article)
  return {
    linkList,
    linkMap,
  }
}
export const renderArticleContent = (article) => renderArticleBase(article).content
